import { Slider } from "@chakra-ui/react";

import { Typography } from "components";
// eslint-disable-next-line no-restricted-imports
import { formatCost } from "utils/format/Money";

import { FilterBase } from "./FilterBase";
import styles from "./FilterPrice.module.css";

interface FilterPriceProps {
  value: number;
  onChange: (val: number) => void;
  onClear?: () => void;
  onApply: () => void;
  isQuestionnaire?: boolean;
  onDismiss?: () => void;
  min?: number;
  max: number;
  step?: number;
}

export const FilterPrice = ({
  value,
  onChange,
  onClear,
  onApply,
  isQuestionnaire = false,
  onDismiss,
  min,
  max,
  step = 200,
}: FilterPriceProps) => (
  <FilterBase
    title="What’s your ideal rent?"
    onClear={onClear}
    onApply={onApply}
    disableClear={value == null || value === max}
    disableApply={false}
    isQuestionnaire={isQuestionnaire}
    onDismiss={onDismiss}
  >
    <section className={styles.sliderContainer}>
      <Slider.Root
        aria-label={["budget-slider"]}
        value={[value ?? max]}
        onValueChange={(details) => onChange(details.value[0] ?? max)}
        min={min}
        max={max}
        step={step}
      >
        <Slider.Control>
          <Slider.Track
            bg="var(--color-secondary-border)"
            h="4px"
            borderRadius="100px"
          >
            <Slider.Range bg="var(--color-primary-btn-bg)" opacity={1} />
          </Slider.Track>
          <Slider.Thumb
            index={0}
            boxSize="16px"
            bg="var(--color-primary-btn-bg)"
            _focus={{ boxShadow: "none" }}
          />
        </Slider.Control>
      </Slider.Root>

      <Typography variant={isQuestionnaire ? "body" : "small"} weight="medium">
        Up to {formatCost(value)} a month
      </Typography>
    </section>
  </FilterBase>
);
